import { createTheme } from "@mui/material";
import {
  DARK_BLUE_COLOR,
  ERROR_COLOR,
  GRAY_COLOR,
  LIGHT_GRAY_COLOR,
  ORANGE_COLOR,
  PRIMARY_COLOR,
  SUCCESS_COLOR,
  TRANSPARENT_WHITE_COLOR,
  WARNING_COLOR,
  WHITE_COLOR,
} from "./variable";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: PRIMARY_COLOR,
      contrastText: WHITE_COLOR,
    },
    secondary: {
      main: DARK_BLUE_COLOR,
      contrastText: WHITE_COLOR,
    },
    success: {
      main: SUCCESS_COLOR,
      contrastText: WHITE_COLOR,
    },
    warning: {
      main: WARNING_COLOR,
      contrastText: WHITE_COLOR,
    },
    white: {
      main: WHITE_COLOR,
      contrastText: WHITE_COLOR,
    },
    error: {
      main: ERROR_COLOR,
      contrastText: WHITE_COLOR,
    },
  },
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 12,
    fontFamily: ["Montserrat"],

    h3: {
      fontSize: 50,
      fontWeight: 600,
      color: DARK_BLUE_COLOR,
    },
    h4: {
      fontSize: 30,
    },
    h5: {
      fontSize: 20,
    },
    h6: {
      fontSize: 18,
    },
    body1: {
      fontSize: 12,
      color: GRAY_COLOR,
    },
    body2: {
      fontSize: 14,
      color: LIGHT_GRAY_COLOR,
    },
    custom13: {
      fontSize: 13,
    },
    caption: {
      fontSize: 10,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 720,
      lg: 960,
      xl: 1280,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "capitalize" },
        // sizeLarge: {
        //   padding: "15px 22px",
        //   fontSize: 14,
        // },
      },
    },
    MuiTimelineItem: {
      styleOverrides: {
        root: {
          "&.MuiTimelineItem-missingOppositeContent": {
            "&:before": {
              display: "none",
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: GRAY_COLOR,

          "&::placeholder": {
            color: DARK_BLUE_COLOR,
          },
        },
      },
    },
    // MuiBackdrop: {
    //   styleOverrides: {
    //     root: {
    //       backdropFilter: "blur(5px)",
    //       background: TRANSPARENT_WHITE_COLOR,
    //     },
    //   },
    // },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: PRIMARY_COLOR,
      contrastText: WHITE_COLOR,
    },
    secondary: {
      main: DARK_BLUE_COLOR,
      contrastText: WHITE_COLOR,
    },
    success: {
      main: SUCCESS_COLOR,
      contrastText: WHITE_COLOR,
    },
    warning: {
      main: ORANGE_COLOR,
      contrastText: WHITE_COLOR,
    },
    error: {
      main: ERROR_COLOR,
      contrastText: WHITE_COLOR,
    },
    background: {
      paper: DARK_BLUE_COLOR,
    },
  },
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 12,
    fontFamily: ["Open Sans"],

    h2: {
      fontSize: 50,
    },
    h4: {
      fontSize: 30,
    },
    h5: {
      fontSize: 20,
    },
    h6: {
      fontSize: 18,
    },
    body1: {
      fontSize: 12,
    },
    body2: {
      fontSize: 14,
    },
    caption: {
      fontSize: 10,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 720,
      lg: 960,
      xl: 1280,
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        containedSizeMedium: {
          padding: "15px 22px",
          fontSize: 14,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: "#fff",
          color: DARK_BLUE_COLOR,
        },
        input: {
          color: DARK_BLUE_COLOR,
          fontSize: 15,
          fontWeight: 500,
          "&::disabled": {
            color: "red !important",
            fontSize: 15,
            fontWeight: 500,
          },
          "&::placeholder": {
            color: DARK_BLUE_COLOR,
            fontSize: 15,
            fontWeight: 500,
          },
        },
      },
    },

    MuiBackdrop: {
      styleOverrides: {
        root: {
          backdropFilter: "blur(5px)",
          background: TRANSPARENT_WHITE_COLOR,
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          overflowY: "inherit",
        },
      },
    },
  },
});
